export class ApiClientError extends Error {
    constructor(message, status, response, data) {
        super(message);
        this.status = status;
        this.response = response;
        this.data = data;
        this.name = 'ApiClientError';
    }
}
//# sourceMappingURL=types.js.map